<template>
    <div class="promoteLink">
        <el-dialog title="推广链接" :visible.sync="dialogVisible" width="304px">
            <p class="commodityName">商品名称：{{commodityName}}</p>
            <div class="twoCodeBox">
                <img src="" alt="二维码">
                <br>
                <span class="download">下载二维码</span>
            </div>
            <div class="linkBox">
                <el-input v-model="link"></el-input><el-button type="primary">复制</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'promoteLink',
    data() {
        return {
            dialogVisible: false,
            commodityName: '',
            img: '',
            link: ''
        }
    },
    methods: {
        promoteLink(name) {
            this.commodityName = name
            this.dialogVisible = true
            
        }
    }
}
</script>
<style lang="scss">
    .promoteLink{
        .el-dialog{
            .commodityName{
                text-align: center;
            }
            .twoCodeBox{
                text-align: center;
                margin-top: 15px;
                width: 134px;
                height: 134px;
                margin: auto;
                img{
                    width: 134px;
                    height: 134px;
                }
                .download{
                    color: #409EFF;
                    margin-top: 10px;
                    cursor: pointer;
                }
            }
            .linkBox{
                margin-top: 30px;
                .el-input{
                    width: 200px;
                    .el-input__inner{
                        border-radius:4px 0px 0px 4px;
                    }
                }
                .el-button{
                    min-width: 0;
                    width: 54px;
                    border-radius:0px 4px 4px 0px;
                }
            }
        }
    }
</style>